
<template> 
  <div class="container">
    <div class="page-header">
      <h1 class="page-title">
        {{ titre }}
        <p class="lead text-muted" v-if="isEdit && horaire.updated_at">
          Dernière modification le {{ prettyTime(horaire.updated_at) }}
        </p>
        <p class="lead text-muted" v-if="!isEdit">
          Définir les journées de collecte pour une région
        </p>
      </h1>
  
      <div class="page-options d-flex">
        <div class="input-group ml-3 pl-3" v-if="isEdit">
          <button type="button" class="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Actions
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="#" v-on:click="supprimerHoraire()">
              Supprimer l'horaire
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-12" v-if="loading"><Spinner></Spinner></div>
      <div class="col-12" v-else>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Nom de l'horaire</label>
                  <input type="text" class="form-control" v-model="horaire.nom" name="nom_horaire" 
                    v-validate="'required'" :class="{ 'is-invalid': errors.has('nom_horaire') }" data-vv-as="Le nom">
                  <div class="invalid-feedback" v-show="errors.has('nom_horaire')">{{ errors.first('nom_horaire') }}</div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label class="form-label mb-0">Description</label>
                  <small class="help-block text-muted">
                    Ceci est visible pour les administrateurs seulement.
                  </small>
                  <textarea rows="2" class="form-control" v-model="horaire.description"></textarea>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <div class="form-label">
                    Document relié à l'horaire
                    <a href="#" v-on:click.prevent="unsetDocument()" class="ml-1 text-red" 
                      v-if="documentHoraireTexte">(Supprimer)</a>
                    <a :href="$storage(horaire.document_horaire_path)" class="ml-1" 
                      v-if="horaire.document_horaire_path && documentHoraireTexte" target="_blank">(Consulter)</a>
                  </div>
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="documentChange" ref="documentHoraire">
                    <label class="custom-file-label">{{ documentHoraireTexte||"Choisir" }}</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <div class="form-group">
                  <label class="form-label mb-0">Horaire des collectes</label>
                  <small class="help-block text-muted">
                    Sélectionez un type de collecte et cliquez sur les dates pour activer/désactiver.
                  </small>

                  <select class="form-control custom-select mb-2" v-model="typeSelectedId">
                    <option :value="type.id" v-for="type in typesCollectes">{{ type.nom }}</option>
                  </select>
  
                  <div id="calendar"></div>
                  <div class="clear-fix"></div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group mb-1">
                  <label class="form-label mb-0">Géolocalisation</label>
                  <small class="help-block text-muted">
                    Décrivez la zone sur la carte.
                  </small>
                  <div class="input-group mb-2">
                    <input type="text" class="form-control" v-model="rechercheVille"
                      placeholder="Ajouter une ville" v-on:keyup.enter.prevent="enterRechercheZone()">
                    <span class="input-group-append">
                      <button class="btn btn-primary" type="button" v-on:click.prevent="enterRechercheZone()">
                        Rechercher
                      </button>
                    </span>
                  </div>

                  <div class="card" v-if="resultatsRechercheZone">
                    <table class="table card-table table-vcenter text-nowrap">
                      <tbody>
                        <tr v-for="zone in resultatsRechercheZone">
                          <td>
                            {{ zone.display_name }}
                          </td>
                          <td class="text-right">
                            <a href="#" class="btn btn-secondary btn-sm" 
                                v-on:click.prevent="ajouterZone(zone, true)">
                              Ajouter en repère
                            </a>
                            <a href="#" class="btn btn-secondary btn-sm" 
                                v-on:click.prevent="ajouterZone(zone)">
                              Ajouter la zone
                            </a>
                          </td>
                        </tr>
                        <tr v-if="resultatsRechercheZone.length == 0" class="text-muted">
                          <td colspan="5"><i>Il n'y a aucun resultat.</i></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div id="map-outer" class="mb-4">
                  </div>

                  <div v-if="curPolygonName || curPolygon">
                    <p v-if="curPolygonName" class="mb-2">
                      <u>Horaire de la zone sélectionnée:</u><br> 
                      <span class="font-weight-bold" style="font-size: 18px;">{{ curPolygonName }}</span>
                    </p>
                    <button class="btn btn-danger" v-if="curPolygon"
                        v-on:click.prevent="supprimerPolygone()">
                      Supprimer la zone sélectionnée
                    </button>
                    <hr class="my-3">
                  </div>
                  
                  <!-- :class="{ 'float-right': !!curPolygon || ajoutZoneEnCours }" -->
                  <div class="mt-4">
                    <button class="btn btn-secondary mr-2" v-on:click.prevent="arretAjouterPolygone()"
                        v-if="ajoutZoneEnCours">
                      <i class="fe fe-check"></i> Sortir du mode ajouter
                    </button>
                    <button class="btn btn-secondary" v-on:click.prevent="ajouterPolygone()">
                      <i class="fe fe-plus"></i> Ajouter une zone
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-12 p-2">
                <button type="submit" class="btn btn-primary" v-on:click.prevent="saveHoraire()">
                  {{ texteSoumettre }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  #cp-wrap{
    position: absolute;
    top: 10px;
    left:120px;
    background-color:white;
  }

  #cp-wrap button{
    font-size: 22px;
  }
</style>

<script>
  import Spinner from 'vue-simple-spinner'
  import moment from 'moment'
  import jsonFormData from 'json-form-data'
  import { prettyTime, randomId } from '../helpers'

  const POLYSTATE = {
    strokeColor: '#BADA55',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#C0FFEE',
    fillOpacity: 0.35
  }

  export default {
    components: {
      Spinner
    },
    data() {
      return {
        titre: "",
        texteSoumettre: "",
        isEdit: false,
        loading: true,
        afficherMap: true,
        rechercheVille: "",
        resultatsRechercheZone: null,
        typesCollectes: [],
        typeSelectedId: null,
        polygons: [],
        curPolygon: null,
        curPolygonName: null,
        ajoutZoneEnCours: false,

        anneeDates: null,
        anneeLoading: null,
        calendarDataSource: [],

        datesHoraire: [],
        datesInsert: [],
        datesRemove: [],

        documentHoraireTexte: null,
        documentHoraireFile: null,
        documentHoraireDelete: false,
        
        horairesPolygonSave: [],
        horaires: [],
        horaire: {
          nom: "",
          description: "",
        },
      }
    },
    created() {
      var self = this;
      var route = this.$route;

      var fetchInitial = function(res) {
        return new Promise((resolve, reject) => {
          // Récupérer l'horaire
          var id = self.$route.params.id;
          Promise.all([ 
            self.$http.get(`horaires`),
            self.$http.get('types_collectes')
          ]).then(function([ horairesRes, typesRes ]) {
            var horaires, types;
            if (horairesRes && horairesRes.body && horairesRes.body.data) {
              horaires = horairesRes.body.data;
              self.horaires = horaires;
            }

            if (typesRes && typesRes.body && typesRes.body.data) {
              types = typesRes.body.data;
              self.typesCollectes = types;
              if (self.typesCollectes.length > 0) {
                self.typeSelectedId = self.typesCollectes[0].id;
              }
            }

            self.loading = false;
            resolve({ horaires, types });
          }).catch(function(err){
            console.log(err);
            reject(err);
          });
        })
      }

      if (route.name == "Horaires.ajouter") {
        this.isEdit = false;
        this.titre = "Créer un horaire de collectes";
        this.texteSoumettre = "Ajouter l'horaire";
        this.$store.commit("setTitle", "Nouvelle horaire");
        fetchInitial();
      } else if (route.name == "Horaires.modifier") {
        this.isEdit = true;
        this.titre = "Mettre à jour l'horaire";
        this.texteSoumettre = this.titre;
        this.$store.commit("setTitle", "Modifier une horaire");

        fetchInitial().then(({ horaires, types }) => {
          var id = self.$route.params.id;
          var horaire = horaires.find(h => h.id == id);                    
          self.horaire = horaire;

          // Affichier le nom du fichier actuel
          var doc_path = self.horaire.document_horaire_path;
          if (doc_path) self.documentHoraireTexte = doc_path.split('/').pop();
        });

        this.loadAnneeCalendar(new Date().getFullYear());
      }
    },
    methods: {
      prettyTime,
      saveHoraire() {
        var self = this;

        self.$validator.validateAll().then((result) => {
          if(result) {
            // obtenir les coordonees des polygones
            var shapes = self.getPolygonShapes(p => {
              return (p.isNew || p.horaireId == self.horaire.id);
            });

            // Obtenir l'état de la map
            var center = self.map.getCenter();
            var mapState = {
              zoom: self.map.getZoom(),
              lng: center.lng(),
              lat: center.lat()
            }

            let horaire = {
              ...self.horaire,
              ...mapState,
              delete_document: self.documentHoraireDelete,
              polygone_json: JSON.stringify(shapes)
            }

            horaire.datesInsert = self.datesHoraire
              .filter(d => d.isNew)
              .map(d => {
                return {
                  date: d.date,
                  type_id: d.type_id
                }
              });

            if (self.documentHoraireFile) {
              horaire.document = self.documentHoraireFile;
            }
            if (self.isEdit) {
              horaire.datesRemove = self.datesRemove;
            }

            var data = jsonFormData(horaire);
            if (self.isEdit) {
              self.$http.post(`horaires/${horaire.id}`, data).then(response => {
                if (response.status == 200) {
                  self.$router.push({ name: 'Horaires' });
                  self.$notify.success("L'horaire a été mis à jour.");
                  self.saveAutresHoraires();
                }
              }, response => {
                // error callback
              });
            } else {
              self.$http.post(`horaires`, data).then(response => {
                if (response.status == 200) {
                  self.$router.push({ name: 'Horaires'});
                  self.$notify.success("L'horaire a été ajouté.");
                  self.saveAutresHoraires();
                }
              }, response => {
                // error callback
              });
            }
          }
        });
      },
      saveAutresHoraires() {
        var self = this;
        var horaires = [];
        for (var i = 0; i < self.horairesPolygonSave.length; i++) {
          let horaireId = self.horairesPolygonSave[i];
          if (horaireId != self.horaire.id) {
            let shapes = self.getPolygonShapes(p => {
              return (p.horaireId == horaireId);
            });
            horaires.push({
              'id': horaireId,
              'polygone_json': JSON.stringify(shapes)
            });
          }
        }

        if (horaires.length > 0) {
          self.$http.post('horaires/update_polygons', {horaires}).then(res => {
            if (res.status == 200) {
              // console.log(horaires);
            }
          }, err => {
            // error callback
            console.error(err);
          });
        }
      },

      supprimerHoraire() {
        var self = this;
        var horaire = self.horaire;

        if (self.isEdit && horaire.id && 
            confirm("Supprimer définitivement cet horaire?")) {
          self.$http.delete(`horaires/${horaire.id}`).then(response => {
            if (response.status == 200) {
              self.$router.push({ name: 'Horaires'});
              this.$notify.info("L'horaire a été supprimé.");
            }
          }, response => {
            // error callback
          });
        }
      },

      documentChange() {
        var files = this.$refs.documentHoraire.files;
        if (files.length > 0) {
          this.documentHoraireFile = files[0];
          this.documentHoraireTexte = files[0].name;
          this.documentHoraireDelete = false;
        }
      },
      unsetDocument() {
        this.documentHoraireTexte = null;
        this.documentHoraireFile = null;
        this.documentHoraireDelete = true;
        $(this.$refs.documentHoraire).val('');
      },

      initCalendar() {
        var self = this;
        var currentYear = new Date().getFullYear();
        var $calendar = $('#calendar');

        $calendar.calendar({ 
          dataSource: self.calendarDataSource,
          language: 'fr',
          enableContextMenu: false,
          enableRangeSelection: true,
          selectRange: function(e) {
            var start = moment(e.startDate);
            var startIso = start.toISOString();
            var end = moment(e.endDate);
            var diffDays = Math.abs(start.diff(end, 'days'));
            if (diffDays == 0) {
              // Ajouter une donnée à ce jour pour le type de collecte sélectionné
              // Enlerver si déja existant pour le type choisi
              if (self.calendar && self.typeSelectedId) {
                var typeSelected = self.typesCollectes.find(t => t.id == self.typeSelectedId);
                if (typeSelected) {
                  var existeIndex = self.datesHoraire.findIndex(d => {
                    return (d.date == startIso && d.type_id == typeSelected.id);
                  });

                  if (existeIndex != -1) {
                    var elemRemove = self.datesHoraire[existeIndex];
                    var dataSource = self.calendar.getDataSource().filter(el => {
                      return (el.id != elemRemove.id);
                    });

                    self.calendar.setDataSource(dataSource);
                    self.calendarDataSource = dataSource;

                    if (!elemRemove.isNew) self.datesRemove.push(elemRemove.id);
                    else self.datesInsert = self.datesInsert.filter(d => d.id != elemRemove.id);

                    self.datesHoraire.splice(existeIndex, 1);
                  } else {
                    var elmId = randomId();
                    self.calendar.addEvent({
                      id: elmId,
                      color: typeSelected.couleur,
                      name: typeSelected.nom,
                      startDate: e.startDate,
                      endDate: e.startDate
                    });

                    var el = {
                      id: elmId, 
                      date: startIso,
                      type_id: typeSelected.id,
                      isNew: true
                    };

                    self.datesInsert.push(el);
                    self.datesHoraire.push(el);
                  }
                }
              }
            }

            $('.popover').remove();
          },
          mouseOnDay: function(e) {
            if(e.events.length > 0) {
              var content = '';
              
              for(var i in e.events) {
                content += '<div class="event-tooltip-content">'
                  + '<div class="event-name" style="color:' 
                  + e.events[i].color + '">' + e.events[i].name + '</div></div>';
              }
          
              $(e.element).popover({ 
                trigger: 'manual',
                container: 'body',
                html: true,
                content: content
              });
              
              $(e.element).popover('show');
            }
          },
          mouseOutDay: function(e) {
            if(e.events.length > 0) {
              $(e.element).popover('hide');
            }
          },
          renderEnd: function(e) {
            var annee = e.currentYear;
            self.loadAnneeCalendar(annee);
          },
        });

        self.calendar = $calendar.data('calendar');
      },

      loadAnneeCalendar(annee) {
        var self = this;
        if (self.isEdit && self.horaire.id &&
            !self.anneeLoading && (self.anneeDates != annee)) {
          self.anneeLoading = true;
          self.$http.get(`horaires/dates/${self.horaire.id}`, { params: {
            annee: annee
          }}).then(dates => {
            if (dates && dates.body && dates.body.data) {
              self.datesHoraire = dates.body.data.map(d => {
                return {...d, date: moment(d.date).toISOString()}
              });
            }

            self.anneeLoading = false;
            self.datesHoraire = self.datesHoraire.concat(self.datesInsert);

            var dataSource = [];
            for (var i = 0; i < self.datesHoraire.length; i++) {
              var d = self.datesHoraire[i];
              var type = self.typesCollectes.find(t => t.id == d.type_id);
              if (type && !self.datesRemove.includes(d.id)) {
                var dateElm = moment(d.date).toDate();
                dataSource.push({
                  ...d, 
                  color: type.couleur,
                  name: type.nom,
                  startDate: dateElm,
                  endDate: dateElm
                });
              }
            }

            self.anneeDates = annee;
            self.calendarDataSource = dataSource;
            if (self.calendar) {
              self.calendar.setDataSource(self.calendarDataSource);
            }
          }, err => {
            console.log(err);
          });        
        }
      },

      initMap(useJson, centerPolygon) {
        $('#map-outer').html(`<div id="map_div" style="height: 800px; width:100%;"></div>` + 
            `<div id='cp-wrap'></div>`);

        //the only global variable
        var self = this;
        var PS = null;
        var initial = {
          "lat": "46.799319",
          "lng": "-71.743374",
          "zoom": 11
        }
        
        if (this.isEdit && this.horaire.lat && this.horaire.lng) {
          initial = {
            "lat": this.horaire.lat,
            "lng": this.horaire.lng,
            "zoom": this.horaire.zoom
          }
        }

        //make the satellite view google map, center it in Vancouver.
        var map = new google.maps.Map(document.getElementById("map_div"), {
          center: new google.maps.LatLng(initial.lat, initial.lng),
          mapTypeId: google.maps.MapTypeId.HYBRID,
          zoom: parseFloat(initial.zoom),
          streetViewControl: false
        });

        this.map = map;

        // Recuperer les polygones sauvegardés
        var polygons = [];
        if (useJson) {
          if (this.horaire.polygone_json) {
            try {
              var polygonsArr = JSON.parse(this.horaire.polygone_json);

              for (var i = 0; i < polygonsArr.length; i++) {
                let polyCords = polygonsArr[i];
                let polyOpts = $.extend({
                  paths: polyCords,
                  map: this.map,
                  snapable: true
                }, POLYSTATE);

                let polyObj = new google.maps.Polygon(polyOpts);
                polyObj.horaireId = this.horaire.id;
                polygons.push(polyObj);
                var indexID = this.registerPolygon(polyObj);
                this.selectPolygon(indexID);
              }
            } catch(e) {
              // ...
            }
          }
        } else {
          for (var i = 0; i < this.polygons.length; i++) {
            let polygon = this.polygons[i];
            polygon.setMap(this.map);
          }
        }

        if (centerPolygon) {
          this.map.fitBounds(centerPolygon.getBounds());
        }

        this.PS = PolySnapper({
          map: map,
          marker: new google.maps.Marker(),
          threshold: 20,
          keyRequired: false,
          polygons: polygons,
          polystyle: POLYSTATE,
          editable: true,
          hidePOI: true
        });

        // Afficher les polygones des autres horaires (non clicables)
        var horaireId = null;
        if (this.isEdit) horaireId = self.horaire.id;
        var autresHoraires = self.horaires.filter(h => h.id != horaireId);
        for (var i = 0; i < autresHoraires.length; i++) {
          let horaireAutre = autresHoraires[i];
          let polygonsArr = JSON.parse(horaireAutre.polygone_json);
          for (var j = 0; j < polygonsArr.length; j++) {
            let polyCords = polygonsArr[j];
            let polyOpts = {
              strokeColor: '#96afd3',
              fillColor: '#aaa',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillOpacity: 0.35,
              paths: polyCords,
              map: self.map,
              snapable: true
            }

            let polyObj = new google.maps.Polygon(polyOpts);
            polyObj.horaireId = horaireAutre.id;
            // console.log(horaireAutre.nom);
            this.registerPolygon(polyObj);
            polygons.push(polyObj);
          }
        }
      },
      
      getPolygonShapes(filter) {
        return this.polygons.filter(filter)
          .map(this.polygonToShapeArray)
          .filter(shape => {
            return (shape && shape.length > 0);
          });
      },

      polygonToShapeArray(polygon) {
        var shape = [];
        var path = polygon.getPath();
        if (path) {
          var len = path.getLength();
          for (var j = 0; j < len; j++) {
            var coord = path.getAt(j);
            var lat = coord.lat();
            var lng = coord.lng();
            shape.push({lat,lng});
          }
          return shape;
        }
      },

      registerPolygon(polygon) {
        var self = this;
        var indexID = randomId();
        polygon.indexID = indexID;
        self.polygons.push(polygon);
        google.maps.event.addListener(polygon, 'click', function (event) {
          if (!self.ajoutZoneEnCours) {
            self.selectPolygon(polygon.indexID);
          }
        });

        if (!polygon.isIndice) {
          let path = polygon.getPath();
          if (path) {
            google.maps.event.addListener(path, 'set_at', function (event) {
              if (polygon.horaireId && !self.horairesPolygonSave.includes(polygon.horaireId)) {
                self.horairesPolygonSave.push(polygon.horaireId);
              }
            });
          }
        }
        return indexID;
      },

      selectPolygon(indexID) {
        var self = this;
        self.curPolygon = null;
        self.curPolygonName = null;
        for (var i = 0; i < self.polygons.length; i++) {
          var polygon = self.polygons[i];
          if (polygon.indexID == indexID) {
            self.curPolygon = polygon;
            if (polygon.isIndice) {
              self.curPolygonName = polygon.indiceName + " (Repère seulement)";
              polygon.setOptions({ 
                fillColor: '#e2dac0',
                editable: false
              });
            } else {
              var isCurrent = (polygon.isNew || polygon.horaireId == self.horaire.id);
              if (isCurrent) {
                self.curPolygonName = self.horaire.nom + " (horaire en cours)";
              } else {
                var horairePoly = self.horaires.find(h => h.id == polygon.horaireId);
                if (horairePoly) self.curPolygonName = horairePoly.nom;
              }

              polygon.setOptions({ 
                fillColor: isCurrent ? '#C0FFEE' : '#96afd3',
                editable: true
              });
            }
          } else {
            polygon.setOptions({ 
              fillColor: '#727272',
              editable: false
            });
          }
        }
      },

      enterRechercheZone() {
        var self = this;
        self.resultatsRechercheZone = null;
        if (self.rechercheVille && self.rechercheVille.length > 0) {
          $.get( "https://nominatim.openstreetmap.org/search.php", {
            q: self.rechercheVille,
            polygon_geojson: 1,
            format: "json"
          }, function( data ) {
            if (data) {
              self.resultatsRechercheZone = data.filter(result => {
                return result.class == "boundary";
              });
              
              console.log(self.resultatsRechercheZone);
            }
          });
        }
      },

      ajouterZone(zone, setIndice) {
        var self = this;
        let polyCords = zone.geojson.coordinates[0].map(arr => {
          return { lng: arr[0], lat: arr[1] }
        });

        let polyOpts = $.extend({
          paths: polyCords,
          snapable: true
        }, POLYSTATE);

        if (setIndice) polyOpts.strokeColor = '#fcd86f';
        let polyObj = new google.maps.Polygon(polyOpts);
        
        if (setIndice) {
          polyObj.isIndice = true;
          polyObj.indiceName = zone.display_name;
        } else {
          polyObj.isNew = true;
        }

        var indiceZone = this.registerPolygon(polyObj);
        this.selectPolygon(indiceZone);

        this.rechercheVille = "";
        this.resultatsRechercheZone = null;
        
        $('#map-outer').html('');
        setTimeout(function() {
          self.initMap(false, polyObj);
        }, 50);
      },

      supprimerPolygone() {
        if (this.curPolygon && confirm("Voulez-vous vraiment supprimer la zone sélectionnée?")) {
          var polygon = this.curPolygon;
          this.curPolygon.setMap(null);
          this.polygons = this.polygons.filter(p => {
            return p.indexID != this.curPolygon.indexID; });
          this.curPolygon = null;
          this.curPolygonName = null;
          if (polygon.horaireId && !this.horairesPolygonSave.includes(polygon.horaireId)) {
            this.horairesPolygonSave.push(polygon.horaireId);
          }
        }
      },

      ajouterPolygone() {
        var self = this;
        self.selectPolygon(null);
        self.PS.enable();
        self.ajoutZoneEnCours = true;
        for (var i = 0; i < self.polygons.length; i++) {
          self.polygons[i].setOptions({ clickable: false });
        }
        setTimeout(function() {
          var polygon = self.PS.polygon();
          polygon.isNew = true;
          var index = self.registerPolygon(polygon);
          self.selectPolygon(index);
        }, 500);
      },

      arretAjouterPolygone() {
        this.ajoutZoneEnCours = false;
        for (var i = 0; i < this.polygons.length; i++) {
          this.polygons[i].setOptions({ 
            clickable: true,
            editable: false
          });
        }
      }
    },
    watch: {
      loading(val) {
        var self = this;
        if (val == false) {
          setTimeout(function() {
            self.initCalendar();
            if (self.afficherMap) {
              self.initMap(true);
            }
          }, 50);
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// HorairesEdit.vue?3d1280f6